import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MusicNotesIcon from "../assets/icons/musicNotesIcon";
import Button from "../components/button";
import Loader from "../components/loader";
import PopUp, { closePopUp } from "../components/popUp";
import { useSafeNavigate } from "../components/unloadBlocker";
import { useAppContext } from "../context/appContext";
import { PieceResponseDTOMin } from "../openapi-generated-client";

interface BuySuccessPopUpProps {
    pieceId?: number;
    refetch: () => void;
}

export default function BuySuccessPopUp(props: BuySuccessPopUpProps) {

    const {purchaseController, sessionId, isLoggedIn} = useAppContext();

    const [data, setData] = useState<PieceResponseDTOMin>();
    const [error, setError] = useState<string | undefined>(undefined);

    async function fetchData() {
        if(data != undefined) return;
        if(!isLoggedIn) {
            setError("You are not logged in.");
        }
        purchaseController.checkPurchaseCheckout(sessionId).catch(error => {
            setError(error.response.data.message);
        }).then((response) => {
            if (response) {
                setData(response.data);
            }
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    const navigate = useSafeNavigate(useNavigate());

    if(data == undefined && error == undefined) {
        return <PopUp className="big buy-success" title="Processing Purchase...">
            <Loader/>
        </PopUp>;
    }

    return <PopUp onClose={() => {
        navigate("/pieces/" + props.pieceId);
    }} className="big buy-success" title="">
        {error ? <>
            <h1>An error occurred</h1>
            <h2>{error}</h2>
            <Button onClick={() => {
                closePopUp();
                navigate("/pieces/" + props.pieceId);
            }}>Close</Button>
        </> : <>
            <h1>Thank You!</h1>
            <h3>Your purchase was successfull.</h3>
            <p>You can now download the piece as often as you like.</p>
            <Button onClick={() => {
                closePopUp();
                navigate("/pieces/" + props.pieceId);
            }}>Awesome!<MusicNotesIcon/></Button>
        </>}
    </PopUp>;

}